import { types } from "mobx-state-tree"

export const DoctorUniversity = types
    .model({
        univercityid: types.optional(types.number, 0),
        univercityName: types.optional(types.string, "")
    }).actions(self => ({

    }))